import {
  FilterParam,
  DeviceFilterAttribute,
  DeviceFilter,
  SoftwareFilter,
  SoftwareFilterAttribute,
} from 'models';
import { RolloutFilter, RolloutFilterAttribute } from 'models/rollout';

// Create filters
export function createFilters<T extends FilterParam>(
  filters: Record<string, string>
): T[] {
  const list: T[] = [];
  Object.entries(filters).forEach(([key, value]) => {
    if (value) {
      list.push({
        attribute: key,
        value,
      } as T);
    }
  });
  return list;
}

export function createDeviceFilterAttribute(input: string): DeviceFilter[] {
  const list = [];
  // CHECK LENGTH
  switch (input.length) {
    case 8:
      list.push({
        attribute: DeviceFilterAttribute.ShortId,
        value: input,
      });
      break;
    case 20:
      list.push({
        attribute: DeviceFilterAttribute.ICCID,
        value: input,
      });
      break;
    case 25:
      list.push({
        attribute: DeviceFilterAttribute.HID,
        value: input,
      });
      break;
    case 36:
      list.push({
        attribute: DeviceFilterAttribute.IprId,
        value: input,
      });
  }
  return list;
}

export const createSoftwareFilterAttribute = (
  input: string
): SoftwareFilter[] => {
  const list = [];
  list.push({
    attribute: SoftwareFilterAttribute.NAME,
    value: input,
  });
  return list;
};

export const createRolloutFilterAttribute = (
  input: string
): RolloutFilter[] => {
  const list = [];
  list.push({
    attribute: RolloutFilterAttribute.NAME,
    value: input,
  });
  return list;
};
